<script>
import { Bubble } from 'vue-chartjs'
import 'chartjs-plugin-annotation'
import 'chartjs-plugin-colorschemes/src/plugins/plugin.colorschemes'
import { Accent8, Paired12, SetThree12 } from 'chartjs-plugin-colorschemes/src/colorschemes/colorschemes.brewer'

export default {
  extends: Bubble,
  props: ['chartdata', 'color'],
  data : function() {
    return {
      colors : [Accent8, Paired12, SetThree12],
      options : {
        responsive: true,
        maintainAspectRatio: false,
        title : {
          display: false
        },
        legend : {
          display: false
        },
        tooltips: {
          displayColors: false,
          callbacks: {
            label: function(t, d) {
               return d.datasets[t.datasetIndex].label;
            }
          }
        },
        annotation: {
          events: ['click'],
          annotations: [{
            drawTime: 'afterDatasetsDraw',
            id: 'hline',
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: this.chartdata.referenceLine.value,
            borderColor: '#212121',
            borderWidth: 3,
            label: {
              backgroundColor: "#212121",
              content: "Média: " + this.chartdata.referenceLine.value,
              enabled: true,
              position: 'right'
            },
          }]
        }

      },
    }
  },
  mounted () {
    const chartData = {
      datasets: this.chartdata.series,
    };

    this.renderChart(chartData, this.options);
  }
}
</script>

<style>
</style>